import { useEffect, useLayoutEffect, useRef } from 'react';
import { releaseBlobUrlHolder, setBlobUrlHolder } from 'src/utils/blobUrlRegistry';

export const useBlobUrlHolder = (urls: readonly (string | null | undefined)[]) => {
  const holder = useRef({});
  // Take ownership before a child file picker releases its previews on unmount.
  useLayoutEffect(() => setBlobUrlHolder(holder.current, urls), [urls]);
  useEffect(() => {
    const current = holder.current;
    return () => releaseBlobUrlHolder(current);
  }, []);
};
